import DesignDataService from "./DesignDataService";
import InteractionService from "./InteractionService";
import ConfiguratorService from "./ConfiguratorService";
import AnalyticsService from "./AnalyticsService";

export default {
  DesignDataService,
  InteractionService,
  ConfiguratorService,
  AnalyticsService,
};
